const DateTime = {
    getDate(config) {
        const date = new Date()
        const days = config && config.days ? config.days : 0
        date.setDate(date.getDate() + days)
        return date
    },
    getDateString(config) {
        return this.dateToString(this.getDate(config))
    },
    dateToString: (date) => {
        return date
            ? `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`
            : null
    },
    stringToDate: (dateString) => {
        if (dateString && dateString != "") {
            const parts = dateString.split(" ")
            // building date
            const _dateSource = parts[0].trim().split("-")
            const day = _dateSource[0]
            const month = _dateSource[1] - 1
            const year = _dateSource[2]
            if (parts.length == 2) {
                // building time
                const _sourceTime = parts[1].trim().split(":")
                const hour = _sourceTime[0]
                const min = _sourceTime[1]
                const sec = _sourceTime[2]
                time = ` ${hour}:${min}:${sec}`
                return new Date(year, month, day, hour, min, sec)
            }
            else {
                return new Date(year, month, day)
            }
        }
        else {
            return null
        }
    },

    // ----------------------------------------------------------------------------------------------------------------------------------------------------------------

    todayString: (config) => {
        // Retorna la fecha de hoy en un String
        const date = new Date()
        const days = config && config.days ? config.days : 0
        date.setDate(date.getDate() + days)
        const format = config && config.format ? config.format : 'dd-mm-yyyy'
        let _date = ""
        switch (format) {
            case 'dd-mm-yyyy':
                _date = `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`
                break
            case 'mm/dd/yyyy':
                _date = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`
                break
        }
        return _date
    },
    todayTime: (config) => {
        // Retorna la fecha y hora de hoy en un String
        const days = config && config.days ? config.days : 0
        const date = new Date()
        date.setDate(date.getDate() + days)
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
    },
    buildDate: ({ year, month, day, hour, min, sec = 0 }) => {
        // Retorna una instancia de Date en función a los datos entregados: dia, mes, año...
        return new Date(year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec)
    },
    buildDate2: (source) => {
        if (!source) return null
        const _source = DateTime.convertStringToObject(source)
        return new Date(_source.year + "-" + _source.month + "-" + _source.day + " " + _source.hour + ":" + _source.min + ":" + _source.sec)
    },
    convertStringToObject: (source) => {
        if (!source) return null
        const date = source.split(" ")[0]
        const time = source.split(" ")[1]
        const dateTime = {
            day: date.split("-")[0],
            month: date.split("-")[1],
            year: date.split("-")[2],
            hour: time.split(":")[0],
            min: time.split(":")[1],
            sec: time.split(":")[2] ? time.split(":")[2] : 0 // verificando si se envia los segundos, si no por defecto 0
        }
        return dateTime
    },
    splitDate: (source) => {
        if (!source) return null
        const dateTime = {
            day: source.getDate() < 10 ? "0" + source.getDate() : source.getDate(),
            month: source.getMonth() < 10 ? "0" + source.getMonth() : source.getMonth(),
            year: source.getFullYear(),
        }
        return dateTime
    },
    splitDateTime: (source) => {
        if (!source) return null
        const dateTime = {
            day: source.getDate() < 10 ? "0" + source.getDate() : source.getDate(),
            month: source.getMonth() < 10 ? "0" + source.getMonth() : source.getMonth(),
            year: source.getFullYear(),
            hour: source.getHours() < 10 ? "0" + source.getHours() : source.getHours(),
            min: source.getMinutes() < 10 ? "0" + source.getMinutes() : source.getMinutes(),
        }
        return dateTime
    },
    convertObjectToString: ({
        day,
        month,
        year,
        hour = "00",
        min = "00",
        sec = "00"
    }) => {
        return `${day}-${month}-${year} ${hour}:${min}:${sec}`
    },
    get24Time: () => {
        return [
            {
                key: "01:00",
                value: "01:00",
            },
            {
                key: "01:30",
                value: "01:30",
            },
            {
                key: "02:00",
                value: "02:00",
            },
            {
                key: "02:30",
                value: "02:30",
            },
            {
                key: "03:00",
                value: "03:00",
            },
            {
                key: "03:30",
                value: "03:30",
            },
            {
                key: "04:00",
                value: "04:00",
            },
            {
                key: "04:30",
                value: "04:30",
            },
            {
                key: "05:00",
                value: "05:00",
            },
            {
                key: "05:30",
                value: "05:30",
            },
            {
                key: "06:00",
                value: "06:00",
            },
            {
                key: "06:30",
                value: "06:30",
            },
            {
                key: "07:00",
                value: "07:00",
            },
            {
                key: "07:30",
                value: "07:30",
            },
            {
                key: "08:00",
                value: "08:00",
            },
            {
                key: "08:30",
                value: "08:30",
            },
            {
                key: "09:00",
                value: "09:00",
            },
            {
                key: "09:30",
                value: "09:30",
            },
            {
                key: "10:00",
                value: "10:00",
            },
            {
                key: "10:30",
                value: "10:30",
            },
            {
                key: "11:00",
                value: "11:00",
            },
            {
                key: "11:30",
                value: "11:30",
            },
            {
                key: "12:00",
                value: "12:00",
            },
            {
                key: "12:30",
                value: "12:30",
            },
            {
                key: "13:00",
                value: "13:00",
            },
            {
                key: "13:30",
                value: "13:30",
            },
            {
                key: "14:00",
                value: "14:00",
            },
            {
                key: "14:30",
                value: "14:30",
            },
            {
                key: "15:00",
                value: "15:00",
            },
            {
                key: "15:30",
                value: "15:30",
            },
            {
                key: "16:00",
                value: "16:00",
            },
            {
                key: "16:30",
                value: "16:30",
            },
            {
                key: "17:00",
                value: "17:00",
            },
            {
                key: "17:30",
                value: "17:30",
            },
            {
                key: "18:00",
                value: "18:00",
            },
            {
                key: "18:30",
                value: "18:30",
            },
            {
                key: "19:00",
                value: "19:00",
            },
            {
                key: "19:30",
                value: "19:30",
            },
            {
                key: "20:00",
                value: "20:00",
            },
            {
                key: "20:30",
                value: "20:30",
            },
            {
                key: "21:00",
                value: "21:00",
            },
            {
                key: "21:30",
                value: "21:30",
            },
            {
                key: "22:00",
                value: "22:00",
            },
            {
                key: "22:30",
                value: "22:30",
            },
            {
                key: "23:00",
                value: "23:00",
            },
            {
                key: "23:30",
                value: "23:30",
            },
            {
                key: "24:00",
                value: "24:00",
            },
            {
                key: "24:30",
                value: "24:30",
            },
        ]
    },
    horas: [
        "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00"
    ],
    horasMinutos: [
        "07:00",
        "07:01",
        "07:02",
        "07:03",
        "07:04",
        "07:05",
        "07:06",
        "07:07",
        "07:08",
        "07:09",
        "07:10",
        "07:11",
        "07:12",
        "07:13",
        "07:14",
        "07:15",
        "07:16",
        "07:17",
        "07:18",
        "07:19",
        "07:20",
        "07:21",
        "07:22",
        "07:23",
        "07:24",
        "07:25",
        "07:26",
        "07:27",
        "07:28",
        "07:29",
        "07:30",
        "07:31",
        "07:32",
        "07:33",
        "07:34",
        "07:35",
        "07:36",
        "07:37",
        "07:38",
        "07:39",
        "07:40",
        "07:41",
        "07:42",
        "07:43",
        "07:44",
        "07:45",
        "07:46",
        "07:47",
        "07:48",
        "07:49",
        "07:50",
        "07:51",
        "07:52",
        "07:53",
        "07:54",
        "07:55",
        "07:56",
        "07:57",
        "07:58",
        "07:59",
        "08:00",
        "08:01",
        "08:02",
        "08:03",
        "08:04",
        "08:05",
        "08:06",
        "08:07",
        "08:08",
        "08:09",
        "08:10",
        "08:11",
        "08:12",
        "08:13",
        "08:14",
        "08:15",
        "08:16",
        "08:17",
        "08:18",
        "08:19",
        "08:20",
        "08:21",
        "08:22",
        "08:23",
        "08:24",
        "08:25",
        "08:26",
        "08:27",
        "08:28",
        "08:29",
        "08:30",
        "08:31",
        "08:32",
        "08:33",
        "08:34",
        "08:35",
        "08:36",
        "08:37",
        "08:38",
        "08:39",
        "08:40",
        "08:41",
        "08:42",
        "08:43",
        "08:44",
        "08:45",
        "08:46",
        "08:47",
        "08:48",
        "08:49",
        "08:50",
        "08:51",
        "08:52",
        "08:53",
        "08:54",
        "08:55",
        "08:56",
        "08:57",
        "08:58",
        "08:59",
        "09:00",
        "09:01",
        "09:02",
        "09:03",
        "09:04",
        "09:05",
        "09:06",
        "09:07",
        "09:08",
        "09:09",
        "09:10",
        "09:11",
        "09:12",
        "09:13",
        "09:14",
        "09:15",
        "09:16",
        "09:17",
        "09:18",
        "09:19",
        "09:20",
        "09:21",
        "09:22",
        "09:23",
        "09:24",
        "09:25",
        "09:26",
        "09:27",
        "09:28",
        "09:29",
        "09:30",
        "09:31",
        "09:32",
        "09:33",
        "09:34",
        "09:35",
        "09:36",
        "09:37",
        "09:38",
        "09:39",
        "09:40",
        "09:41",
        "09:42",
        "09:43",
        "09:44",
        "09:45",
        "09:46",
        "09:47",
        "09:48",
        "09:49",
        "09:50",
        "09:51",
        "09:52",
        "09:53",
        "09:54",
        "09:55",
        "09:56",
        "09:57",
        "09:58",
        "09:59",
        "10:00",
        "10:01",
        "10:02",
        "10:03",
        "10:04",
        "10:05",
        "10:06",
        "10:07",
        "10:08",
        "10:09",
        "10:10",
        "10:11",
        "10:12",
        "10:13",
        "10:14",
        "10:15",
        "10:16",
        "10:17",
        "10:18",
        "10:19",
        "10:20",
        "10:21",
        "10:22",
        "10:23",
        "10:24",
        "10:25",
        "10:26",
        "10:27",
        "10:28",
        "10:29",
        "10:30",
        "10:31",
        "10:32",
        "10:33",
        "10:34",
        "10:35",
        "10:36",
        "10:37",
        "10:38",
        "10:39",
        "10:40",
        "10:41",
        "10:42",
        "10:43",
        "10:44",
        "10:45",
        "10:46",
        "10:47",
        "10:48",
        "10:49",
        "10:50",
        "10:51",
        "10:52",
        "10:53",
        "10:54",
        "10:55",
        "10:56",
        "10:57",
        "10:58",
        "10:59",
        "11:00",
        "11:01",
        "11:02",
        "11:03",
        "11:04",
        "11:05",
        "11:06",
        "11:07",
        "11:08",
        "11:09",
        "11:10",
        "11:11",
        "11:12",
        "11:13",
        "11:14",
        "11:15",
        "11:16",
        "11:17",
        "11:18",
        "11:19",
        "11:20",
        "11:21",
        "11:22",
        "11:23",
        "11:24",
        "11:25",
        "11:26",
        "11:27",
        "11:28",
        "11:29",
        "11:30",
        "11:31",
        "11:32",
        "11:33",
        "11:34",
        "11:35",
        "11:36",
        "11:37",
        "11:38",
        "11:39",
        "11:40",
        "11:41",
        "11:42",
        "11:43",
        "11:44",
        "11:45",
        "11:46",
        "11:47",
        "11:48",
        "11:49",
        "11:50",
        "11:51",
        "11:52",
        "11:53",
        "11:54",
        "11:55",
        "11:56",
        "11:57",
        "11:58",
        "11:59",
        "12:00",
        "12:01",
        "12:02",
        "12:03",
        "12:04",
        "12:05",
        "12:06",
        "12:07",
        "12:08",
        "12:09",
        "12:10",
        "12:11",
        "12:12",
        "12:13",
        "12:14",
        "12:15",
        "12:16",
        "12:17",
        "12:18",
        "12:19",
        "12:20",
        "12:21",
        "12:22",
        "12:23",
        "12:24",
        "12:25",
        "12:26",
        "12:27",
        "12:28",
        "12:29",
        "12:30",
        "12:31",
        "12:32",
        "12:33",
        "12:34",
        "12:35",
        "12:36",
        "12:37",
        "12:38",
        "12:39",
        "12:40",
        "12:41",
        "12:42",
        "12:43",
        "12:44",
        "12:45",
        "12:46",
        "12:47",
        "12:48",
        "12:49",
        "12:50",
        "12:51",
        "12:52",
        "12:53",
        "12:54",
        "12:55",
        "12:56",
        "12:57",
        "12:58",
        "12:59",
        "13:00",
        "13:01",
        "13:02",
        "13:03",
        "13:04",
        "13:05",
        "13:06",
        "13:07",
        "13:08",
        "13:09",
        "13:10",
        "13:11",
        "13:12",
        "13:13",
        "13:14",
        "13:15",
        "13:16",
        "13:17",
        "13:18",
        "13:19",
        "13:20",
        "13:21",
        "13:22",
        "13:23",
        "13:24",
        "13:25",
        "13:26",
        "13:27",
        "13:28",
        "13:29",
        "13:30",
        "13:31",
        "13:32",
        "13:33",
        "13:34",
        "13:35",
        "13:36",
        "13:37",
        "13:38",
        "13:39",
        "13:40",
        "13:41",
        "13:42",
        "13:43",
        "13:44",
        "13:45",
        "13:46",
        "13:47",
        "13:48",
        "13:49",
        "13:50",
        "13:51",
        "13:52",
        "13:53",
        "13:54",
        "13:55",
        "13:56",
        "13:57",
        "13:58",
        "13:59",
        "14:00",
        "14:01",
        "14:02",
        "14:03",
        "14:04",
        "14:05",
        "14:06",
        "14:07",
        "14:08",
        "14:09",
        "14:10",
        "14:11",
        "14:12",
        "14:13",
        "14:14",
        "14:15",
        "14:16",
        "14:17",
        "14:18",
        "14:19",
        "14:20",
        "14:21",
        "14:22",
        "14:23",
        "14:24",
        "14:25",
        "14:26",
        "14:27",
        "14:28",
        "14:29",
        "14:30",
        "14:31",
        "14:32",
        "14:33",
        "14:34",
        "14:35",
        "14:36",
        "14:37",
        "14:38",
        "14:39",
        "14:40",
        "14:41",
        "14:42",
        "14:43",
        "14:44",
        "14:45",
        "14:46",
        "14:47",
        "14:48",
        "14:49",
        "14:50",
        "14:51",
        "14:52",
        "14:53",
        "14:54",
        "14:55",
        "14:56",
        "14:57",
        "14:58",
        "14:59",
        "15:00",
        "15:01",
        "15:02",
        "15:03",
        "15:04",
        "15:05",
        "15:06",
        "15:07",
        "15:08",
        "15:09",
        "15:10",
        "15:11",
        "15:12",
        "15:13",
        "15:14",
        "15:15",
        "15:16",
        "15:17",
        "15:18",
        "15:19",
        "15:20",
        "15:21",
        "15:22",
        "15:23",
        "15:24",
        "15:25",
        "15:26",
        "15:27",
        "15:28",
        "15:29",
        "15:30",
        "15:31",
        "15:32",
        "15:33",
        "15:34",
        "15:35",
        "15:36",
        "15:37",
        "15:38",
        "15:39",
        "15:40",
        "15:41",
        "15:42",
        "15:43",
        "15:44",
        "15:45",
        "15:46",
        "15:47",
        "15:48",
        "15:49",
        "15:50",
        "15:51",
        "15:52",
        "15:53",
        "15:54",
        "15:55",
        "15:56",
        "15:57",
        "15:58",
        "15:59",
        "16:00",
        "16:01",
        "16:02",
        "16:03",
        "16:04",
        "16:05",
        "16:06",
        "16:07",
        "16:08",
        "16:09",
        "16:10",
        "16:11",
        "16:12",
        "16:13",
        "16:14",
        "16:15",
        "16:16",
        "16:17",
        "16:18",
        "16:19",
        "16:20",
        "16:21",
        "16:22",
        "16:23",
        "16:24",
        "16:25",
        "16:26",
        "16:27",
        "16:28",
        "16:29",
        "16:30",
        "16:31",
        "16:32",
        "16:33",
        "16:34",
        "16:35",
        "16:36",
        "16:37",
        "16:38",
        "16:39",
        "16:40",
        "16:41",
        "16:42",
        "16:43",
        "16:44",
        "16:45",
        "16:46",
        "16:47",
        "16:48",
        "16:49",
        "16:50",
        "16:51",
        "16:52",
        "16:53",
        "16:54",
        "16:55",
        "16:56",
        "16:57",
        "16:58",
        "16:59",
        "17:00",
        "17:01",
        "17:02",
        "17:03",
        "17:04",
        "17:05",
        "17:06",
        "17:07",
        "17:08",
        "17:09",
        "17:10",
        "17:11",
        "17:12",
        "17:13",
        "17:14",
        "17:15",
        "17:16",
        "17:17",
        "17:18",
        "17:19",
        "17:20",
        "17:21",
        "17:22",
        "17:23",
        "17:24",
        "17:25",
        "17:26",
        "17:27",
        "17:28",
        "17:29",
        "17:30",
        "17:31",
        "17:32",
        "17:33",
        "17:34",
        "17:35",
        "17:36",
        "17:37",
        "17:38",
        "17:39",
        "17:40",
        "17:41",
        "17:42",
        "17:43",
        "17:44",
        "17:45",
        "17:46",
        "17:47",
        "17:48",
        "17:49",
        "17:50",
        "17:51",
        "17:52",
        "17:53",
        "17:54",
        "17:55",
        "17:56",
        "17:57",
        "17:58",
        "17:59",
        "18:00",
        "18:01",
        "18:02",
        "18:03",
        "18:04",
        "18:05",
        "18:06",
        "18:07",
        "18:08",
        "18:09",
        "18:10",
        "18:11",
        "18:12",
        "18:13",
        "18:14",
        "18:15",
        "18:16",
        "18:17",
        "18:18",
        "18:19",
        "18:20",
        "18:21",
        "18:22",
        "18:23",
        "18:24",
        "18:25",
        "18:26",
        "18:27",
        "18:28",
        "18:29",
        "18:30",
        "18:31",
        "18:32",
        "18:33",
        "18:34",
        "18:35",
        "18:36",
        "18:37",
        "18:38",
        "18:39",
        "18:40",
        "18:41",
        "18:42",
        "18:43",
        "18:44",
        "18:45",
        "18:46",
        "18:47",
        "18:48",
        "18:49",
        "18:50",
        "18:51",
        "18:52",
        "18:53",
        "18:54",
        "18:55",
        "18:56",
        "18:57",
        "18:58",
        "18:59",
        "19:00",
        "19:01",
        "19:02",
        "19:03",
        "19:04",
        "19:05",
        "19:06",
        "19:07",
        "19:08",
        "19:09",
        "19:10",
        "19:11",
        "19:12",
        "19:13",
        "19:14",
        "19:15",
        "19:16",
        "19:17",
        "19:18",
        "19:19",
        "19:20",
        "19:21",
        "19:22",
        "19:23",
        "19:24",
        "19:25",
        "19:26",
        "19:27",
        "19:28",
        "19:29",
        "19:30",
        "19:31",
        "19:32",
        "19:33",
        "19:34",
        "19:35",
        "19:36",
        "19:37",
        "19:38",
        "19:39",
        "19:40",
        "19:41",
        "19:42",
        "19:43",
        "19:44",
        "19:45",
        "19:46",
        "19:47",
        "19:48",
        "19:49",
        "19:50",
        "19:51",
        "19:52",
        "19:53",
        "19:54",
        "19:55",
        "19:56",
        "19:57",
        "19:58",
        "19:59",
        "20:00",
        "20:01",
        "20:02",
        "20:03",
        "20:04",
        "20:05",
        "20:06",
        "20:07",
        "20:08",
        "20:09",
        "20:10",
        "20:11",
        "20:12",
        "20:13",
        "20:14",
        "20:15",
        "20:16",
        "20:17",
        "20:18",
        "20:19",
        "20:20",
        "20:21",
        "20:22",
        "20:23",
        "20:24",
        "20:25",
        "20:26",
        "20:27",
        "20:28",
        "20:29",
        "20:30",
        "20:31",
        "20:32",
        "20:33",
        "20:34",
        "20:35",
        "20:36",
        "20:37",
        "20:38",
        "20:39",
        "20:40",
        "20:41",
        "20:42",
        "20:43",
        "20:44",
        "20:45",
        "20:46",
        "20:47",
        "20:48",
        "20:49",
        "20:50",
        "20:51",
        "20:52",
        "20:53",
        "20:54",
        "20:55",
        "20:56",
        "20:57",
        "20:58",
        "20:59",
        "21:00",
    ]
}

export default DateTime